import React, { useState } from 'react';
import Modal from 'react-modal';
import ModalEditForm from './ModalEditForm';
import { createNotification } from '../notifications/notifications';
import { notificationsLibrary } from '../../utils/notificationsLibrary.js';

const ModalTable = ({ modalData, editBook, deleteBook }) => {

  const [showModal, setShowModal] = useState(false);
  const [editModalData, setModalData] = useState({});
  const parentId = modalData.id;

  const requestEditForm = (values, bookId) => {
    editBook(values, bookId, parentId)
      .then(() => {
        setShowModal(false);
        createNotification('success', notificationsLibrary['04']);
      })
      .catch(() => createNotification('error', notificationsLibrary['06']));
  }

  const requestDeleteBook = (bookId) => {
    deleteBook(bookId, parentId)
      .then(() => {
        setShowModal(false);
        createNotification('success', notificationsLibrary['03']);
      })
      .catch(() => createNotification('error', notificationsLibrary['09']));
  }

  const requestEditLoad = (data) => {
    setShowModal(true);
    setModalData(data);
  }

  const renderModalRow = (row, index) => {
    return (
      <tr key={`bres${index}`}
        className="booksRequest__table-row"
        onClick={() => requestEditLoad(row)}
      >
        <td className="td-center">
          {row.title}
        </td>
        <td className="td-center">
          {row.author}
        </td>
        <td className="td-center">
          {row.isbn}
        </td>
        <td className="td-center">
          {row.publisher}
        </td>
        <td className="td-center">
          {row.amount}
        </td>
        <td className="td-center">
          {row.digital_amount}
        </td>
      </tr>
    );
  }

  return (
    <div>
      <Modal
        isOpen={showModal}
        contentLabel="SmallModal"
        onRequestClose={() => setShowModal(false)}
        className="StudentProjectSmallModal"
      >
        <ModalEditForm
          editBook={requestEditForm}
          deleteBook={requestDeleteBook}
          modalData={editModalData}
        />
      </Modal>
      <div className="captions">Добавить книги в заказ на поступление литературы</div>
      <table className="ModalTable">
        <thead>
          <tr>
            <th className="table-title">Название</th>
            <th className="table-title">Автор</th>
            <th className="table-title">ISBN</th>
            <th className="table-title">Издательство</th>
            <th className="table-title">бумажн. кол-во</th>
            <th className="table-title">электр. кол-во</th>
          </tr>
        </thead>
        <tbody>
          {modalData.books && modalData.books.map(renderModalRow)}
        </tbody>
      </table>
    </div>
  )
}

export default ModalTable;
